import {IState} from '../../../core/IState';

export const UnavailableState: IState = {
    name: 'unavailable',
    url: '/unavailable',
    template: require('../templates/unavailable.html'),
    data: {
        title: 'Page Not Found'
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/unavailable/states/UnavailableState.ts
 **/